// extracted by css-extract-rspack-plugin
export default {"root":"root-e0N1SE","onboardingWrapper":"onboardingWrapper-UZ7zSx","docsWrapper":"docsWrapper-uIOgSn","txfDocumentationWrapper":"txfDocumentationWrapper-walyt1"};